import { useTranslation } from "react-i18next";

interface ConversionFunnelProps {
  free: number;
  paid: number;
}

export function ConversionFunnel({ free, paid }: ConversionFunnelProps) {
  const { t } = useTranslation();
  const total = free + paid;
  const conversionRate = total > 0 ? ((paid / total) * 100).toFixed(1) : "0";

  return (
    <div className="rounded-xl border-2 border-black bg-white p-8 shadow-[4px_4px_0_#000] h-full">
      <h3 className="mb-6 text-2xl font-black tracking-tight">{t('admin.sales.funnel.title')}</h3>
      
      <div className="space-y-6">
        <div>
          <div className="mb-2 flex justify-between text-sm font-bold">
            <span>{t('admin.sales.funnel.totalUsers')}</span>
            <span>{total}</span>
          </div>
          <div className="h-6 w-full border-2 border-black bg-gray-100 rounded-lg overflow-hidden">
            <div className="h-full bg-[#FFD93D]" style={{ width: '100%' }} />
          </div>
        </div>

        <div className="flex flex-col items-center py-2">
          <div className="h-8 w-0.5 bg-black" />
          <div className="rounded-full border-2 border-black bg-white px-3 py-1 text-xs font-black">
            {t('admin.sales.funnel.rate', { rate: conversionRate })}
          </div>
          <div className="h-8 w-0.5 bg-black" />
        </div>

        <div>
          <div className="mb-2 flex justify-between text-sm font-bold">
            <span>{t('admin.sales.funnel.paidUsers')}</span>
            <span>{paid}</span>
          </div>
          <div className="h-6 w-full border-2 border-black bg-gray-100 rounded-lg overflow-hidden">
            <div 
              className="h-full bg-[#6FEDD6]" 
              style={{ width: total > 0 ? `${(paid / total) * 100}%` : '0%' }} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}
